import React, { useContext, useEffect, useState } from "react";
import * as yup from "yup";
import ApiActions from "api_actions";
import MyToast from "components/toast/toast";

import { Formik, Form, Field, ErrorMessage } from "formik";

import styles from "./bottom_tab.module.css";
import { BookingDataContext } from "containers/data_context";
import { Button, Col, Nav, Row } from "react-bootstrap";
import PolicyCheckbox from "components/payment_form/submit_booking_button/policy_checkbox";

const MemberManagment = ({ open, setOpen }) => {
  const { channelId } = useContext(BookingDataContext);
  const [toast, setToast] = useState({ text: null, type: null });
  const [isPolicyAccepted, setIsPolicyAccepted] = useState(false);

  const [isToastShown, setIsToastShown] = useState(false);
  const getSchema = yup.object({
    phone: yup.number().typeError("Phone Number must be numeric").required(),
    email: yup
      .string()
      .required("Valid email is required.")
      .email("Please enter a valid email address."),
  });

  useEffect(() => {
    if (toast.text && !isToastShown) {
      setIsToastShown(true);
    }
  }, [toast, isToastShown]);

  const handleSubmit = async (values, { setSubmitting }) => {
    await loginMember(values);
    setSubmitting(false);
  };
  const loginMember = async (values) => {
    const data = await ApiActions.getDiscount(values.email, values.phone, channelId);

    if (data?.data?.length === 0) {
      setToast({
        text: "You are not a member, Please first become a member to get discount",
        type: "error",
      });
    } else {
      const memberData = {
        id: data?.data[0]?.id,
        name: data?.data[0]?.name,
        email: data?.data[0]?.email,
        discount: data?.data[0]?.discount,
        country_code: data?.data[0]?.country,
        phone: values?.phone,
        channelId: channelId,
        login_type: "member",
        email_verified: data?.data?.[0]?.email_verified,
      };
      if (!memberData?.email_verified) {
        await ApiActions.verifyMember(memberData?.id);
        setToast({
          text: "Ops your email is not verified,Please verfiy to enjoy membership perks.",
          type: "warning",
        });
        return;
      }

      localStorage.setItem("userInfo", JSON.stringify(memberData));
      window.dispatchEvent(new Event("storage"));
      setToast({ text: "Member logined Successfully", type: "success" });
    }
  };

  useEffect(() => {
    if (isToastShown) {
      setTimeout(() => {
        setOpen(false);
      }, 2000);
    }
  }, [isToastShown, setOpen]);

  return (
    <div className={`${styles.bottom_sheet} ${open ? styles.show : ""}`}>
      <div className={styles.sheet_content}>
        <p className={`${styles.label} text-center`}>Login Member</p>
        <Formik
          initialValues={{
            email: "",
            phone: "",
          }}
          validationSchema={getSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form>
              <Row>
                <Col>
                  <label className={styles.label}>Phone Number:</label>
                  <Field type="tel" name="phone" className={styles.input} />
                  <ErrorMessage name="phone" component="div" className={styles.error} />
                </Col>
                <Col>
                  <label className={styles.label}>Email:</label>
                  <Field type="email" name="email" className={styles.input} />
                  <ErrorMessage name="email" component="div" className={styles.error} />
                </Col>
              </Row>

              <Row>
                <Col>
                  <div className={styles.btngroup}>
                    <PolicyCheckbox value={isPolicyAccepted} onChange={setIsPolicyAccepted} />
                  </div>
                </Col>
              </Row>

              <div className={styles.btngroup}>
                <button
                  type="submit"
                  disabled={isSubmitting || !isPolicyAccepted}
                  className={`${styles.submitbtn} ${
                    isSubmitting || !isPolicyAccepted ? styles.disabled : styles.enabled
                  }`}
                >
                  Submit
                </button>

                <button
                  className={styles.cancelbtn}
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  Cancel
                </button>
              </div>
            </Form>
          )}
        </Formik>

        {isToastShown && (
          <MyToast
            text={toast.text}
            type={toast.type}
            show={toast.text !== null}
            setShow={() => setToast({ text: null, type: null })}
          />
        )}
      </div>
    </div>
  );
};
export default MemberManagment;
